import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/usuarios`, options)
    .then(response => {
      return {
        list: response.data
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/usuarios/${id}`, options)
    .then(response => {
      response.data['phone'] = response.data['telefono']
      response.data['name'] = response.data['nombre']
      response.data['rol'] = response.data['roles'][0]['id']
      return response.data;
    });
}

function add(user) {
  const payload = user;
  payload['rol']= "student";
  
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/usuarios`, payload, options)
    .then(response => {
      return response.data;
    });
}

function addAsAdmin(user) {
  const payload = user;
  payload['rol']= "student";
  
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/usuarios/habilitarComoAdmin`, payload, options)
    .then(response => {
      return response.data;
    });
}

function update(user) {
  const payload = user;
  payload.nombre = user.name;
  payload.telefono = user.phone;

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/usuarios/${user.id}`, payload, options)
    .then(response => {
      return response.data;
    });
}

function updatePassword(user) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/usuarios/update-password/${user.id}`, user, options)
    .then(response => {
      return response.data;
    });
}

function resetPassword(email) {
  const payload = {
    email: email
  };

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/forgot-password`, payload, options)
    .then(response => {
      return response;
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/usuarios/${id}`, options);
}

function enable(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/usuarios/habilitar/${id}`, options);
}

function upload(user, image) {
  const bodyFormData = new FormData();
  bodyFormData.append('attachment', image);

  return axios.post(`${url}/uploads/usuarios/${user.id}/profile-image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  enable,
  upload,
  updatePassword,
  resetPassword,
  addAsAdmin
};

